import React from 'react';

const VideoPlayer = ({ videoUrl, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-4 rounded-lg shadow-xl max-w-4xl w-full mx-4">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-medium text-gray-900">Video Recording</h3>
                    <div className="flex items-center space-x-8">
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-500 p-1.5 hover:bg-gray-100 rounded-full transition-colors duration-200"
                        >
                            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                <video
                    className="w-full rounded-lg"
                    controls
                    autoPlay
                    src={videoUrl}
                >
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    );
};

export default VideoPlayer;